import hsFetch from 'js/sign-components/common/hs-fetch';

export type AiSummaryResponseType = {
  summary: string;
};

export type AiSummaryArgsType = {
  id: string;
};

export type AiTsmGroupGuidFromPreloadedKeyArgsType = {
  preloadedTsmGroupKey: string;
};

export type AiTsmGroupGuidFromPreloadedKeyResponseType = {
  tsmGroupGuid: string;
};

export type AiUserDataResponseType = {
  account: {
    guid: string,
  };
};

export type AiSummaryTranslationArgsType = {
  preloadedTsmGroupKey: string;
  language: string;
};

export type AiSummaryTranslationResponseType = {
  translation: string;
};


export async function getAiSummaryForSigner({
  id,
}: AiSummaryArgsType): Promise<AiSummaryResponseType> {
  const url = `/signAi/GetAiSummaryForSigner?tsm_guid=${id}`;
  const response = await hsFetch(url);
  return response.json();
}

export async function getAiSummaryForPrepAndSend({
  id,
}: AiSummaryArgsType): Promise<AiSummaryResponseType> {
  const url = `/signAi/getAiSummaryForPrepAndSend?preloaded_tsm_group_key=${id}`;
  const response = await hsFetch(url);
  return response.json();
}

export async function getAiSummaryTranslation({
  preloadedTsmGroupKey,
  language,
}: AiSummaryTranslationArgsType): Promise<AiSummaryTranslationResponseType> {
  const url = `/signAi/getAiSummaryTranslation?preloaded_tsm_group_key=${preloadedTsmGroupKey}&language=${language}`;
  const response = await hsFetch(url);
  return response.json();
}

export async function getTsmGroupGuidFromPreloadedKey({
  preloadedTsmGroupKey,
}: AiTsmGroupGuidFromPreloadedKeyArgsType): Promise<AiTsmGroupGuidFromPreloadedKeyResponseType> {
  const url = `/signAi/getTsmGroupGuid?preloaded_tsm_group_key=${preloadedTsmGroupKey}`;
  const response = await hsFetch(url);
  return response.json();
}

export async function getUserData(): Promise<AiUserDataResponseType> {
  const url = '/signAi/getUserData';
  const response = await hsFetch(url);
  return response.json();
}
